<template>
	<div>
		<div class="modal" id="modaldialog" @click.self="close">
			<div>
				<div class="outercontainer">
					<transition name="fade" v-show="!motifselectorshown">
						<div class="modalbusyoverlay" v-if="isAppBusyModal">
							<div class="busyloader"><div><div></div><div></div><div></div><div></div></div></div>
						</div>
					</transition>
					<div v-show="!motifselectorshown">
						<a data-href @click.prevent="close">Luk</a>
						<h3 v-text="dialogTitle">
							Opret bestilling
						</h3>
					</div>
					<section v-show="!motifselectorshown">
						<div class="ordernavigator">
							<a href="#" @click.prevent="gotoPerson(-1)" data-ic="Y">Forrige bestilling</a>
							<a @click.prevent="collapseEdit()" ref="collapseditanchor" data-ic="0"></a>
							<a href="#" @click.prevent="gotoPerson(1)" data-icr="Z">Næste bestilling</a>
						</div>
						<div :class="{'ordereditcollapsed': editIsCollapsed}">
							<form ref="form" @submit.prevent>

								<div class="expandarea">

									<div class="form-groups personhighlight">
										<div class="form-group">
											<div class="input-group" v-if="person">
												<label>
													{{ person.firstname }} {{ person.lastname }}
													<div class="small faded">{{ person.persongroupname }}, {{ person.customername }}</div>
												</label>
												<div class="condensedhidden">
													<template v-if="person.type == 2">
														{{ person.address }}
														<br />
														{{ person.zipcode }} {{ person.city }}
													</template>
													<template v-if="person.type == 4">
														{{ person.emailaddress }}
													</template>

													<div style="margin-top: 10px;">
														<button class="small outline" @click.self="editPerson()">Rediger person</button>
													</div>
												</div>
											</div>

										</div>

										<div class="form-group">

											<div class="input-group" ref="statusgroup">
												<label for="status" class="condensedhidden">
													Bestillings information
												</label>
												<table class="orderinfo">
													<tr>
														<th>
															Ordre status:
														</th>
														<td style="text-align: left; position: relative;">
															<span v-html="getOrderStatus()"></span><span onclick="" class="infoicon" data-ic="2"></span>
															<div class="infoicon-text">
																<ul>
																	<li>
																		<strong>Ikke oprettet</strong><br />
																		Ingen ordre er oprettet for personen.
																	</li>
																	<li>
																		<strong>Kladde</strong><br />
																		Oprettet men uden krævet data
																	</li>
																	<li>
																		<strong>Oprettet</strong><br />
																		Oprettet med krævet data
																	</li>
																	<li>
																		<strong>Betalingslink</strong><br />
																		Betalingslink er sendt til kunden
																	</li>
																	<li>
																		<strong>Betalt</strong><br />
																		Kunden har gennemført bestillingen
																	</li>
																	<li>
																		<strong>Leveret</strong><br />
																		Bestillingen er leveret til kunden
																	</li>
																	<li>
																		<strong>Refunderet</strong><br />
																		Bestillingsbeløbet er blevet refunderet
																	</li>
																	<li>
																		<strong>Rykker 1 - 3</strong><br />
																		Rykker 1, 2 eller 3 er sendt til kunden
																	</li>
																</ul>
															</div>
														</td>
													</tr>
													<tr>
														<th>
															Person status:
														</th>
														<td style="text-align: left; position: relative;">
															<span v-html="getPersonStatus()"></span><span onclick="" class="infoicon" data-ic="2"></span>
															<div class="infoicon-text">
																<ul>
																	<li>
																		<strong>Kladde</strong><br />
																		Personen er oprettet, men uden krævet data
																	</li>
																	<li>
																		<strong>Kan inviteres</strong><br />
																		Billeder og data tilføjet men link ikke sendt til kunde
																	</li>
																	<li>
																		<strong>Link sendt</strong><br />
																		Webshop link er sendt til kunde
																	</li>
																	<li>
																		<strong>Omfotografering</strong><br />
																		Kunde ønsker omfotografering
																	</li>
																	<li>
																		<strong>Annulleret</strong><br />
																		Kunden ønsker ikke at købe
																	</li>
																</ul>
															</div>
														</td>
													</tr>
													<tr class="condensedhidden" v-if="orderID != 0">
														<th>
															Oprettet
														</th>
														<td>
															{{ showPrettyDate(createddate) }}
														</td>
													</tr>
													<tr class="condensedhidden" v-if="orderID != 0">
														<th>
															Opdateret af kunde
														</th>
														<td v-if="statuschangeddate">
															{{ showPrettyDate(statuschangeddate) }}
														</td>
														<td v-if="!statuschangeddate">
															Aldrig
														</td>
													</tr>
													<tr class="condensedhidden" v-if="clientnotes">
														<th>
															Kommentar fra kunde
														</th>
														<td>
															{{ clientnotes }}
														</td>
													</tr>
													<tr class="condensedhidden" v-if="dialogMode == 'edit'">
														<td colspan="2" style="padding-top: 10px;">
															<button @click.prevent="createOrderCopy" class="small outline">Kopier ordre</button>
														</td>
													</tr>
												</table>

												<div style="margin-top: 10px;" class="condensedhidden" v-if="orderID != 0">
													<button class="small outline" @click.self="editPerson()" v-if="false">Historik</button>
												</div>
											</div>
										</div>
									</div>

									<div class="divider condensedhidden" v-if="orderID != 0 && orderCanBeEdited"></div>

									<div class="form-groups condensedhidden" v-if="orderID != 0 && orderCanBeEdited">

										<div class="form-group">
											<div class="input-group">
												<label>
													Webshop link ({{ agreementLanguage }})
												</label>

												<table class="orderinfo" style="width: auto;">
													<tr>
														<td>
															<button class="small outline" @click.prevent="sendWebshopLink">Send link til kunde</button>
														</td>
														<td>
															<button class="small outline" @click.self="copyOrderingUrl()">Kopier link</button>
															<input ref="orderingUrlHiddenInput" style="position: absolute; opacity: 0; pointer-events: none; top: 0;" type="text" />
														</td>
													</tr>
												</table>

												<div style="padding-top: 10px;" class="small faded" v-if="order.requestlinkfirstsent || person.requestlinklastsent">
													<template v-if="person.requestlinkfirstsent">
														Link sendt første gang: {{ showPrettyDate(person.requestlinkfirstsent) }}
														<br />
													</template>
													<template>
														Link sidst sendt: {{ showPrettyDate(person.requestlinklastsent) }}
													</template>
												</div>
											</div>

											<div class="input-group" ref="statusgroup">
												<label for="status">
													Webshop kode
												</label>
												<table class="orderinfo">
													<tr v-if="orderID != 0">
														<th>
															<input type="text" :value="requestcode" readonly="readonly" />
														</th>
														<td style="padding-left: 10px;">
															<button class="small outline" style="padding: 0 16px" @click.self="sendNewWebshopCode">Send ny kode til kunde</button>
														</td>
													</tr>
												</table>

												<div style="padding-top: 10px;" class="small faded" v-if="person && (person.requestcodefirstsent || person.requestcodelastsent)">
													<template v-if="person.requestlinkfirstsent">
														Kode sendt første gang: {{ showPrettyDate(person.requestcodefirstsent) }}
														<br />
													</template>
													<template>
														Kode sidst sendt: {{ showPrettyDate(person.requestcodelastsent) }}
													</template>
												</div>
											</div>
										</div>
										<div class="form-group condensedhidden">
											<div class="input-group-hori">
												<div class="input-group nopad">
													<label for="agreementwebshopperiod">
														Webshop start og udløbsdato
													</label>
												</div>
											</div>
											<div class="input-group-hori">
												<div>

													<VueCtkDateTimePicker v-model="webshopperiod"
																		  :no-label="true"
																		  :no-header="true"
																		  :only-date="true"
																		  :auto-close="true"
																		  button-color="#000"
																		  color="#000"
																		  hint="name"
																		  :first-day-of-week="1"
																		  :no-button-now="true"
																		  :no-shortcuts="true"
																		  :range="true"
																		  placeholder="Vælg periode" />
												</div>
												<div class="nopad">
													<button type="button" class="icon small" @click="webshopperiod = null">Ryd</button>
												</div>
											</div>
											<div style="padding-top: 10px;" class="small faded" v-if="agreement">
												Aftale datoer: {{ getAgreementWebshopDates() }}
											</div>
										</div>
									</div>

									<div class="divider condensedhidden" v-if="orderCanBeEdited || orderHasPaymentStatus"></div>

									<div class="form-groups condensedhidden" v-if="orderCanBeEdited || orderHasPaymentStatus">

										<div class="form-group">

											<div class="input-group" ref="statusgroup">
												<label for="status">
													Betaling
												</label>
												<table class="orderinfo">
													<tr>
														<th>
															Betalings status:
														</th>
														<td v-html="getOrderPaymentStatus()"></td>
													</tr>
													<tr v-if="!orderHasPaymentStatus">
														<th>
															Gratis
														</th>
														<td @click="setFreeOrderValue">
															<input type="checkbox" ref="freeordercheckbox" id="freeorder" /><label for="freeorder"> Sæt bestilling som gratis</label>
														</td>
													</tr>
													<tr v-if="!orderHasPaymentStatus">
														<th>
															Rabat %
														</th>
														<td>
															<input type="number" max="100" min="0" ref="discounttextbox" id="discounttextbox" v-model="discountpercent" />
														</td>
													</tr>
													<tr v-if="order.id">
														<th>
															Ordrenummer:
														</th>
														<td>
															{{ order.ordernumber }}
														</td>
													</tr>
													<tr v-if="order.paymentid">
														<th>
															Transaktions ID:
														</th>
														<td>
															{{ order.paymentid }}
														</td>
													</tr>
													<tr v-if="getPaymentReminderWasSent()">
														<th>
															Rykkergebyr
														</th>
														<td>
															{{ getOrderReminderFee() }},-
														</td>
													</tr>
													<tr v-if="getOrderHasBeenCompleted()">
														<th>
															Beløb
														</th>
														<td>
															{{ getOrderTotalPrice() }},-
														</td>
													</tr>
												</table>
											</div>

										</div>

										<div class="form-group" v-if="!orderHasPaymentStatus">
											<div class="input-group" ref="paymentlinkgroup">
												<label>
													Betalings link
												</label>

												<button v-if="orderHasProducts" class="small outline" @click.prevent="sendPaymentLink" style="max-width: 200px">Send betalings link</button>
												<div v-if="!orderHasProducts">Tilføj mindst en pakke til ordre for at sende den som betalingslink.</div>
												<div v-if="paymentlinklastsent" class="small">Sidst sendt {{ showPrettyDate(this.paymentlinklastsent) }}</div>

											</div>

											<div class="input-group" ref="paymentremindersgroup" v-if="orderHasProducts">
												<label>
													Rykkere
												</label>

												<button class="small outline" @click.prevent="sendPaymentReminder(1)" style="max-width: 200px">Send rykker 1<br /><span class="small">(Uden gebyr)</span></button>
												<div v-if="paymentreminder1lastsent" class="small">Sidst sendt {{ showPrettyDate(this.paymentreminder1lastsent) }}</div><br />

												<button class="small outline" @click.prevent="sendPaymentReminder(2)" style="max-width: 200px">Send rykker 2<br /><span class="small">(100kr gebyr)</span></button>
												<div v-if="paymentreminder2lastsent" class="small">Sidst sendt {{ showPrettyDate(this.paymentreminder2lastsent) }}</div><br />

												<button class="small outline" @click.prevent="sendPaymentReminder(3)" style="max-width: 200px">Send rykker 3<br /><span class="small">(2x100kr. gebyr)</span></button>
												<div v-if="paymentreminder3lastsent" class="small">Sidst sendt {{ showPrettyDate(this.paymentreminder3lastsent) }}</div>
											</div>


										</div>

										<div class="form-group" v-if="orderHasPaymentStatus">

											<div class="input-group" ref="statusgroup">
												<label for="status">
													Kvittering
												</label>
												<button class="small outline" @click.prevent="sendReceipt" style="max-width: 250px">Send kvittering til kunde</button>
											</div>
										</div>
									</div>

								</div>

								<div class="spacersmall"></div>

								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="namegroup">
											<label for="name">
												Navn
											</label>
											<input v-model="name" type="text" ref="name" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('name')">
											<div></div>

											<autocomplete :search="search" type="text" v-if="false"></autocomplete>
										</div>
										<div class="input-group" ref="emailgroup">
											<label for="email">
												Email
											</label>
											<input v-model="email" type="text" ref="email" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('emailaddress')">
										</div>

										<div class="input-group" ref="mobilenumbergroup">
											<label for="mobilenumber">
												Mobilnummer
											</label>
											<input v-model="mobilenumber" type="text" ref="mobilenumber" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('mobilenumber')">
										</div>
									</div>

									<div class="form-group">

										<div class="input-group" ref="addressgroup" v-if="person && person.type == 2">
											<label for="address">
												Adresse
											</label>
											<input v-model="address" type="text" ref="address" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('address')">
										</div>

										<div class="input-group" ref="zipcodegroup" v-if="person && person.type == 2">
											<label for="zipcode">
												Postnummer
											</label>
											<input v-model="zipcode" type="text" ref="zipcode" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('zipcode')">
										</div>

										<div class="input-group" ref="citygroup" v-if="person && person.type == 2">
											<label for="city">
												By
											</label>
											<input v-model="city" type="text" ref="city" :readonly="!orderCanBeEdited" v-on:keyup="checkOrderContactInfoChanged('city')">
										</div>
									</div>

									<div class="form-group">
										<div class="input-group" ref="notesgroup">
											<label for="notes">
												Egne noter
											</label>
											<textarea v-model="notes" ref="notes"></textarea>
										</div>
									</div>

								</div>

								<div class="spacersmall"></div>

								<div class="form-groups">
									<div class="form-group form-group-fullwidth" ref="productsgroup">
										<div class="input-group" ref="imagesgroup">
											<label>
												Billeder
											</label>

											<div id="mediaupload">

												<div class="draganddropcontainer" :class="{'isdropping': isdropping}">
													<draggable :disabled="!orderCanBeEdited"
															   group="pictures"
															   class="previews"
															   v-bind="dragOptions"
															   :list="files"
															   v-if="!isuploading && files.length > 0"
															   @change="setDraggableSort()">
														<div v-for="(file) in files" :key="file.index" class="media">
															<img :src="getImagePreviewUrl(file)" :title="file.name" :alt="file.name" /><span v-if="orderCanBeEdited" title="Fjern billede" v-on:click.prevent="removeFile(file.index)"></span>
															<div><span class="index">#{{ file.index }}</span><span class="filename">{{ file.name }}</span></div>
														</div>
													</draggable>
													<label v-if="orderCanBeEdited" class="text" ref="uploaddraganddropcontainer" for="upload">Tryk eller slip filer her for at uploade.</label>
													<input v-if="orderCanBeEdited" type="file" id="upload" ref="upload" multiple="multiple" v-on:change="handleFileUploadChanged">
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="form-groups">
									<div class="form-group">
										<div class="input-group" ref="productpackagesgroup">
											<label style="margin-bottom: 5px;">
												Billede pakker
											</label>
											<div v-if="agreement" class="faded" style="margin-bottom: 5px;">Aftale: {{ agreement.name }}</div>
										</div>
									</div>
								</div>

								<div class="spacersmall"></div>

								<div class="picturepackages">

									<div v-for="(orderproductpackage) in (picturePackageOrderProductPackages)" :key="orderproductpackage.id">
										<div class="form-groups">
											<div class="form-group">
												<div class="input-group-hori">

													<div class="orderproductpackagesmotif">
														<div :disabled="!files || files.length == 0" :class="{ 'motif' : true, 'disabled' : !files || files.length == 0 }" @click="showMotifSelector(orderproductpackage.id)">
															<img v-if="getOrderProductPackageChosenMotif(orderproductpackage)" :src="getOrderProductPackageChosenMotif(orderproductpackage)" :title="getOrderProductPackageChosenMotifFilename(orderproductpackage)" :alt="getOrderProductPackageChosenMotifFilename(orderproductpackage)" />
															<span v-if="!getOrderProductPackageChosenMotif(orderproductpackage)">
																Vælg<br />
																motiv
															</span>
														</div>
														<div v-if="getOrderProductPackageChosenMotif(orderproductpackage)" class="index">#{{ getOrderProductPackageChosenMotifIndex(orderproductpackage) }}</div>
														<input v-if="getOrderProductPackageChosenMotif(orderproductpackage)" type="text" :value="getOrderProductPackageChosenMotifFilename(orderproductpackage)" readonly="readonly" id="chosenmotiffilenametextbox" />
													</div>

													<div class="orderproductpackages">
														<div :class="{'disabled': orderproductpackage.productpackageid != 0 && orderproductpackage.productpackageid != element.productpackageid, 'selected': getProductPackageQuantity(element, orderproductpackage) > 0 }" v-for="(element) in (getPackageTypeProductPackages(orderproductpackage.type))" :key="element.productpackageid" :title="element.internalname">
															<div>
																<div>
																	{{ element.internalname }}<br />
																	<span class="small faded">( {{ element.name }} )</span>
																</div>
																<div>
																	<button v-if="orderCanBeEdited" class="tiny add" data-ic="O" @click.self="setOrderProductPackage(element, orderproductpackage, 1)"></button>
																	<button v-if="orderCanBeEdited" class="tiny subtract" data-ic="X" @click.self="unsetOrderProductPackage(orderproductpackage)"></button>
																	<div v-if="getProductPackageQuantity(element, orderproductpackage) > 0">{{ getProductPackageQuantity(element, orderproductpackage) }} stk.</div>
																</div>
																<div>
																	{{ getProductPackagePrice(element, orderproductpackage) }},-
																</div>
															</div>
															<div class="options" v-if="dataloaded">
																<template v-for="(property) in (productPackageMediaProperties)">
																	<span :key="property.value">
																		<input :disabled="!orderCanBeEdited" @click.self="mediaPropertyChange(property, orderproductpackage)" type="radio" :checked="getProductPackageMediaPropertySelected(property, orderproductpackage)" :name="'mediaproperty-' + element.productpackageid + '-' + property.value + '-' + orderproductpackage.id" :ref="'mediaproperty-' + element.productpackageid + '-' + property.value + '-' + orderproductpackage.id" :id="'mediaproperty-' + element.productpackageid + '-' + property.value + '-' + orderproductpackage.id" :value="property.value" />
																		<label :disabled="!orderCanBeEdited" :for="'mediaproperty-' + element.productpackageid + '-' + property.value + '-' + orderproductpackage.id">{{ property.name }}</label>
																	</span>
																</template>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div class="form-group">

												<div class="input-group" ref="addonpackagesgroup">
													<div class="orderproductpackages">
														<div :class="{'selected': getChildProductPackageQuantity(element, orderproductpackage) > 0 }" v-for="(element) in (packageTypeExtraProductPackages)" :key="element.productpackageid" :title="element.internalname">
															<div>
																<div>
																	{{ element.internalname }}<br />
																	<span class="small faded">( {{ getProductPackageType(element) }} )</span>
																</div>
																<div>
																	<button v-if="orderCanBeEdited" class="tiny add" data-ic="O" @click.self="setChildOrderProductPackageQuantity(element, 1, orderproductpackage)"></button>
																	<button v-if="orderCanBeEdited" class="tiny subtract" data-ic="X" @click.self="setChildOrderProductPackageQuantity(element, -1, orderproductpackage)"></button>
																	<div v-if="getChildProductPackageQuantity(element, orderproductpackage) > 0">{{ getChildProductPackageQuantity(element, orderproductpackage) }} stk.</div>
																</div>
																<div>
																	{{ getProductPackagePrice(element, orderproductpackage) }},-
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

										</div>
										<div class="spacersmall"></div>
										<div class="removebuttoncontainer"><a href="#" class="faded" @click.prevent="removeOrderProductPackage(orderproductpackage)">Fjern pakke</a></div>
										<div class="dividersmall"></div>
									</div>

									<div class="center">
										<div class="spacersmall"></div>
										<button class="small addpackagebuttoncontainer" @click.prevent="addPicturePackage('picturepackage')" style="margin-right: 20px;">Tilføj billede pakke</button>
										<button class="small addpackagebuttoncontainer" @click.prevent="addPicturePackage('afterpicturepackage')">Tilføj ny motiv pakke</button>
									</div>

								</div>

								<div class="spacer"></div>

								<div class="form-groups">
									<div class="form-group">
										<div class="input-group">
											<label>
												Tilkøbs pakker
											</label>
										</div>
									</div>
								</div>

								<div class="spacersmall"></div>

								<div class="extrapackages">

									<div class="form-groups">

										<div class="form-group">

											<div class="input-group" ref="addonpackagesgroup">

												<div class="orderproductpackages">
													<div :class="{'selected': getExtraProductPackageQuantity(element) > 0 }" v-for="(element) in (nonPackageTypeProductPackages)" :key="element.productpackageid" :title="element.internalname">
														<div>
															<div>
																{{ element.internalname }}<br />
																<span class="small faded">( {{ getProductPackageType(element) }} )</span>
															</div>
															<div>
																<button v-if="orderCanBeEdited" class="tiny add" data-ic="O" @click.self="setExtraOrderProductPackageQuantity(element, 1)"></button>
																<button v-if="orderCanBeEdited" class="tiny subtract" data-ic="X" @click.self="setExtraOrderProductPackageQuantity(element, -1)"></button>
																<div v-if="getExtraProductPackageQuantity(element) > 0">{{ getExtraProductPackageQuantity(element) }} stk.</div>
															</div>
															<div>
																{{ getExtraProductPackagePrice(element) }},-
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>

								<div class="spacer"></div>

								<div class="form-groups">
									<div class="form-group">
										<div class="input-group">

											<div class="orderproductpackages total">
												<div>
													<div class="sums" v-if="orderPersonCount > 1">
														<div>I alt for {{ person.firstname }}</div>
														<div></div>
														<div>
															<strong>{{ getOrderTotalPricePerson() }},-</strong>
														</div>
													</div>
													<div class="sums" v-if="orderPersonCount > 1">
														<div>I alt for andre personer</div>
														<div></div>
														<div>
															<strong>{{ getOrderTotalPriceOtherPersons() }},-</strong>
														</div>
													</div>
													<div class="sums" v-if="orderPersonCount > 1">
														<div>Fælles</div>
														<div></div>
														<div>
															<strong>{{ getOrderTotalPriceServicePackages() }},-</strong>
														</div>
													</div>

													<div v-if="getOrderReminderFee() > 0">
														<div>Rykkergebyr</div>
														<div></div>
														<div>
															<strong>{{ getOrderReminderFee() }},-</strong>
														</div>
													</div>

													<div>
														<div>Ordre i alt</div>
														<div></div>
														<div>
															<strong>{{ getOrderTotalPrice() }},-</strong>
														</div>
													</div>

													<div class="sums" v-if="discountPercentCalculated > 0">
														<div>Rabat {{ discountPercentCalculated }}%</div>
														<div></div>
														<div>
															<strong>{{ getOrderDiscount() }},-</strong>
														</div>
													</div>

													<div v-if="discountPercentCalculated > 0">
														<div>Ordre med rabat</div>
														<div></div>
														<div>
															<strong>{{ getOrderTotalPriceWithDiscount() }},-</strong>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="divider"></div>

								<div class="buttons-group">
									<button type="button" @click.prevent="deleteData" class="delete left" v-if="dialogMode == 'edit'">
										Slet
									</button>
									<button type="button" @click.prevent="close" class="text">
										Tilbage
									</button>
									<button ref="OnlySaveButton" type="button" @click.prevent="saveData(false, true)" v-if="dialogMode == 'edit'">
										Gem
									</button>
									<button ref="SaveButton" type="button" @click.prevent="saveData(false)">
										Opret bestilling
									</button>
									<button ref="SaveAndContinueButton" type="button" @click.prevent="saveData(true)">
										Opret og fortsæt
									</button>
								</div>
							</form>
						</div>
					</section>
					<transition name="fade">
						<div id="motifselector" v-if="motifselectorshown">
							<h4>Vælg motiv</h4>
							<div class="motifcontainer">
								<div v-for="(file) in files" :key="file.index" :class="{ 'media': true, 'selected': getIsMotifSelected(file.index) }" @click.prevent="selectMotif(file.index)">
									<img :src="getImagePreviewUrl(file)" :title="file.name" :alt="file.name" />
									<div><span class="index">#{{ file.index }}</span><span class="filename">{{ file.name }}</span></div>
								</div>
							</div>
							<div class="spacersmall"></div>
							<div>
								<button @click.prevent="hideMotifSelector()">Luk</button>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { types } from "@/app/types/types"
	import { appFeedbackStateEnum } from "@/app/enums/common"
	import { personTypeEnum } from "@/app/enums/common"
	import { productPackageTypeEnum } from "@/app/enums/common"
	import { orderStatusEnum, personStatusEnum } from "@/app/enums/common"
	import { orderPaymentStatusEnum } from "@/app/enums/common"
	import { mediaPropertiesList } from "@/app/enums/common"
	import draggable from "vuedraggable"
	import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
	import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
	import Autocomplete from '@trevoreyre/autocomplete-vue'

	export default {
		name: "OrderEdit",
		components: {
			draggable,
			VueCtkDateTimePicker,
			Autocomplete
		},
		data()
		{
			return {
				dialogMode: "create",
				dialogTitle: "Opret bestilling",
				motifselectorshown: false,
				agreementID: 0,
				customerID: 0,
				persongroupID: 0,
				personID: 0,
				orderID: 0,
				previousPersonID: 0,
				nextPersonID: 0,
				isFind: false,
				isFromOrders: false,
				editIsCollapsed: true,
				dataloaded: false,
				agreementLanguage: "Dansk",
				motifselectorproductpackageid: null,
				editChanges: false,
				orderContactInfoChanged: false,
				orderPersonCount: 1,
				paymentlinklastsent: null,
				paymentreminder1lastsent: null,
				paymentreminder1fee: 0,
				paymentreminder2lastsent: null,
				paymentreminder2fee: 0,
				paymentreminder3lastsent: null,
				paymentreminder3fee: 0,

				// Upload
				files: [], // PersonMediaFile
				isuploading: false,
				isdropping: false,

				person: {},
				agreement: null,

				// Productpackages
				allProductPackages: [],
				noProductPackages: true,
				packageProductPackageID: 0,

				// Media properties
				mediaproperties: [],

				// Order
				orderid: 0,
				status: 0,
				discountpercent: 0,
				paymentstatus: 1,
				createddate: "",
				statuschangeddate: "",
				expirationdate: "",
				orderproductpackages: [],
				notes: "",
				clientnotes: "",
				name: "",
				email: "",
				mobilenumber: "",
				address: "",
				zipcode: "",
				city: "",
				transactionid: "",
				totalprice: "",
				webshopperiod: null,
				requestkey: "",
				requestcode: "",

				order:
				{
					id: 0,
					customerid: 0,
					status: 0,
					discountpercent: 0,
					paymentstatus: 1,
					productpackages: [],
					notes: "",
					clientnotes: "",
					name: "",
					email: "",
					mobilenumber: "",
					address: "",
					city: "",
					zipcode: "",
					transactionid: null,
					totalprice: 0,
				},

				countries: [
					"Denmark", "Sweden", "America"
				]
			}
		},
		mounted()
		{
			this.setModalIsVisible()
			this.loadData()

			this.$refs.form.addEventListener("drop", function (e) { e.preventDefault(); e.stopPropagation() }.bind(this))
			this.$refs.form.addEventListener("dragover", function (e) { e.preventDefault(); e.stopPropagation() }.bind(this))

			if (this.orderCanBeEdited)
			{
				["drag", "dragstart", "dragend", "dragenter", "dragleave"].forEach(function (evt)
				{
					this.$refs.uploaddraganddropcontainer.addEventListener(evt, function (e)
					{
						this.isdropping = (e.type == "drag" || e.type == "dragstart" || e.type == "dragover" || e.type == "dragenter")
					}.bind(this), false)
				}.bind(this))

				this.files = []

				this.$refs.uploaddraganddropcontainer.addEventListener("drop", function (e)
				{
					this.isdropping = false
					this.isuploading = true

					for (let i = 0; i < e.dataTransfer.files.length; i++)
					{
						let file = e.dataTransfer.files[i]
						file.index = this.files.length + 1
						file.sort = this.files.length + 1
						file.isnew = true
						this.files.push(file)
					}

					this.editChanges = true
					this.isuploading = false
				}.bind(this))
			}
		},
		watch:
		{
			"$route": "loadData"
		},
		destroyed()
		{
			this.setModalNotVisible()
		},
		computed:
		{
			discountPercentCalculated()
			{
				return this.discountpercent
			},
			orderHasProducts()
			{
				return this.orderID != 0 && this.getOrderTotalPrice() > 0
			},
			orderHasPaymentStatus()
			{
				return this.orderID != 0 &&
					(this.status == orderStatusEnum.COMPLETED ||
						this.status == orderStatusEnum.DELIVERED ||
						this.status == orderStatusEnum.REFUNDED)
			},
			dragOptions()
			{
				return {
					easing: "cubic-bezier(1, 0, 0, 1)",
					animation: 200,
					ghostClass: "ghost",
					dragClass: "chosen"
				}
			},
			picturePackageOrderProductPackages()
			{
				if (!this.orderproductpackages || this.orderproductpackages.length == 0)
				{
					return []
				}

				return this.orderproductpackages.filter(opp => opp.personid == this.personID && (opp.type == productPackageTypeEnum.PICTUREPACKAGE || opp.type == productPackageTypeEnum.PICTUREPACKAGESECONDARY || opp.type == productPackageTypeEnum.AFTERPICTUREPACKAGE))
			},
			packageTypeProductPackages()
			{
				if (!this.allProductPackages || this.allProductPackages.length == 0)
				{
					return []
				}

				let agreementPackages = this.agreement.productpackages

				return this.allProductPackages.filter((data) =>
				{
					// Only show packages for the chosen agreement
					let agreementPackage = agreementPackages.find(pp => pp.productpackageid == data.productpackageid)
					if (!agreementPackage)
					{
						return null
					}

					let productPackage = data.type == productPackageTypeEnum.PICTUREPACKAGE || data.type == productPackageTypeEnum.PICTUREPACKAGESECONDARY
					return productPackage
				}).sort((a, b) =>
				{
					if (a.type == productPackageTypeEnum.PICTUREPACKAGE)
					{
						return -1
					}
					else
					{
						return 1
					}
				})

			},
			packageTypeExtraProductPackages()
			{
				if (!this.allProductPackages || this.allProductPackages.length == 0)
				{
					return []
				}

				return this.allProductPackages.filter((data) =>
				{
					let productPackage = (data.type == productPackageTypeEnum.PICTUREPACKAGEEXTRA)
					return productPackage
				})
			},
			nonPackageTypeProductPackages()
			{
				if (!this.allProductPackages || this.allProductPackages.length == 0)
				{
					return []
				}

				return this.allProductPackages.filter((data) =>
				{
					let productPackage =
						(data.type != productPackageTypeEnum.PICTUREPACKAGE &&
							data.type != productPackageTypeEnum.PICTUREPACKAGEEXTRA &&
							data.type != productPackageTypeEnum.PICTUREPACKAGESECONDARY &&
							data.type != productPackageTypeEnum.AFTERPICTUREPACKAGE)
					return productPackage
				})
			},
			productPackageMediaProperties()
			{
				return this.mediaproperties
			},
			orderCanBeEdited()
			{
				// Always allow editing for now.
				return true
				/*return (this.order.status == orderStatusEnum.NOTCREATED) ||
					(this.order.status == orderStatusEnum.DRAFT) ||
					(this.order.status == orderStatusEnum.READY) ||
					(this.order.status == orderStatusEnum.READYCLIENTNOTIFIED) ||
					(this.order.status == orderStatusEnum.CLIENTREQUESTEDRESHOOT) ||
					(this.order.status == orderStatusEnum.CANCELLED);*/
			}
		},
		methods:
		{
			async createOrderCopy()
			{
				if (!confirm("Ønsker du at oprette en kopi af ordren?"))
				{
					return
				}

				this.setAppAsBusyModal()
				var data = { orderid: this.orderID, personid: this.personID }
				var result = await this.$store.dispatch(types.ACTION_CREATE_ORDERCOPY, data)

				if (result && result.status && result.status == 200)
				{
					var newOrderID = result.data
					this.$router.push({ name: "OrderEdit", params: { agreementid: this.agreementID, customerid: this.customerID, personid: this.personID, persongroupid: this.persongroupID, orderid: newOrderID } })
					location.reload()
					this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
					this.setAppAsIdle()
				}
				else
				{
					this.setAppAsIdle()
					this.showErrorAlert("Der opstod en fejl ved kopiering af ordren. Opdater siden og prøv igen.")
				}
			},
			getPackageTypeProductPackages(type)
			{
				if (!this.allProductPackages || this.allProductPackages.length == 0)
				{
					return []
				}

				let agreementPackages = this.agreement.productpackages

				return this.allProductPackages.filter((data) =>
				{
					// Only show packages for the chosen agreement
					let agreementPackage = agreementPackages.find(pp => pp.productpackageid == data.productpackageid)
					if (!agreementPackage)
					{
						return null
					}

					if (type == productPackageTypeEnum.PICTUREPACKAGE || type == productPackageTypeEnum.PICTUREPACKAGESECONDARY)
					{
						let productPackage = data.type == type || data.type == productPackageTypeEnum.PICTUREPACKAGESECONDARY
						return productPackage
					}
					else if (type == productPackageTypeEnum.AFTERPICTUREPACKAGE)
					{
						let productPackage = data.type == productPackageTypeEnum.AFTERPICTUREPACKAGE
						return productPackage
					}
				}).sort((a, b) =>
				{
					if (a.type == productPackageTypeEnum.PICTUREPACKAGE)
					{
						return -1
					}
					else
					{
						return 1
					}
				})

			},
			checkOrderContactInfoChanged(element)
			{
				switch (element)
				{
					case "name":
						this.orderContactInfoChanged = (this.$refs.name.value != this.person.information.clientname)
						break
					case "emailaddress":
						this.orderContactInfoChanged = (this.$refs.email.value != this.person.information.clientemailaddress)
						break
					case "mobilenumber":
						this.orderContactInfoChanged = (this.$refs.mobilenumber.value != this.person.information.clientmobilenumber)
						break
					case "address":
						this.orderContactInfoChanged = (this.$refs.address.value != this.person.address)
						break
					case "zipcode":
						this.orderContactInfoChanged = (this.$refs.zipcode.value != this.person.zipcode)
						break
					case "city":
						this.orderContactInfoChanged = (this.$refs.city.value != this.person.city)
						break
				}
			},
			setOrderProductPackage(element, orderproductpackage, quantityChange)
			{
				const findorderproductpackage = this.orderproductpackages.find(opp => opp.id == orderproductpackage.id)

				if (findorderproductpackage)
				{
					findorderproductpackage.name = element.name
					findorderproductpackage.internalname = element.internalname
					findorderproductpackage.productpackage = element.productpackage
					findorderproductpackage.orderproductpackageid = 0
					findorderproductpackage.orderid = this.orderID
					findorderproductpackage.productpackageid = element.productpackageid
					findorderproductpackage.productpackageprice = element.productpackageprice
					findorderproductpackage.type = orderproductpackage.type
					findorderproductpackage.quantity = 1
				}

				this.editChanges = true
			},
			unsetOrderProductPackage(orderproductpackage)
			{
				let findorderproductpackage = this.orderproductpackages.find(opp => opp.id === orderproductpackage.id)

				if (findorderproductpackage)
				{
					findorderproductpackage.name = ""
					findorderproductpackage.internalname = ""
					findorderproductpackage.productpackage = null
					findorderproductpackage.orderproductpackageid = 0
					findorderproductpackage.orderid = this.orderID
					findorderproductpackage.productpackageid = 0
					findorderproductpackage.productpackageprice = 0
					findorderproductpackage.quantity = 0
				}

				this.editChanges = true
			},
			addPicturePackage(type)
			{
				if (type == 'afterpicturepackage')
				{
					var productPackage = this.allProductPackages.find(productpackage => productpackage.type == productPackageTypeEnum.AFTERPICTUREPACKAGE)

					if (!productPackage)
					{
						alert("Der er ikke tilknyttet nogen matchende pakker til aftalen.");
						return
					}
				}
				else if (type == 'afterpicturepackage')
				{
					var productPackage = this.allProductPackages.find(productpackage => productpackage.type == productPackageTypeEnum.PICTUREPACKAGE)

					if (!productPackage)
					{
						alert("Der er ikke tilknyttet nogen matchende pakker til aftalen.")
						return
					}
				}

				let newOrderProductPackageId = -1

				this.orderproductpackages.forEach(orderproductpackage =>
				{
					if (orderproductpackage.id < 1)
					{
						newOrderProductPackageId = orderproductpackage.id - 1
					}
				})

				const agreementproductpackage = this.getDefaultAgreementProductPackage(type)
				agreementproductpackage.id = newOrderProductPackageId

				if (type == 'picturepackage')
				{
					agreementproductpackage.type = productPackageTypeEnum.PICTUREPACKAGE
				}
				else if (type == 'afterpicturepackage')
				{
					agreementproductpackage.type = productPackageTypeEnum.AFTERPICTUREPACKAGE
				}

				this.orderproductpackages.push(agreementproductpackage)
				this.editChanges = true
			},
			getOrderProductPackageChosenMotifFilename(orderproductpackage)
			{
				if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
				{
					return orderproductpackage.selectedmediafiles[0].personmediafile.name
				}

				return null
			},
			getOrderProductPackageChosenMotifIndex(orderproductpackage)
			{
				if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
				{
					return orderproductpackage.selectedmediafiles[0].personmediafile.index
				}

				return null
			},
			getOrderProductPackageChosenMotif(orderproductpackage)
			{
				if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
				{
					if (orderproductpackage.selectedmediafiles[0].personmediafile)
					{
						return orderproductpackage.selectedmediafiles[0].personmediafile.url
					}
				}

				return null
			},
			getIsMotifSelected(fileindex)
			{
				const orderproductpackage = this.orderproductpackages.find(opp => opp.id == this.motifselectorproductpackageid)
				const mediafile = this.files.find(mf => mf.index == fileindex)

				if (mediafile && orderproductpackage && orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
				{
					if (orderproductpackage.selectedmediafiles[0].personmediafile)
					{
						return orderproductpackage.selectedmediafiles[0].personmediafile.index == mediafile.index
					}
				}

				return false
			},
			selectMotif(fileindex)
			{
				const orderproductpackage = this.orderproductpackages.find(opp => opp.id == this.motifselectorproductpackageid)
				const personMediaFile = this.files.find(mf => mf.index == fileindex)

				if (personMediaFile && orderproductpackage)
				{
					if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
					{
						orderproductpackage.selectedmediafiles[0].personmediafileid = personMediaFile.id
						orderproductpackage.selectedmediafiles[0].mediafileid = personMediaFile.mediafileid
						orderproductpackage.selectedmediafiles[0].personmediafile = personMediaFile
					}
					else
					{
						orderproductpackage.selectedmediafiles = [{
							personmediafileid: personMediaFile.id,
							mediafileid: personMediaFile.mediafileid,
							personmediafile: personMediaFile
						}]
					}
				}

				this.$refs.productpackagesgroup.removeAttribute("data-validation")
				this.hideMotifSelector()
				this.editChanges = true
			},
			showMotifSelector(orderproductpackageid)
			{
				this.motifselectorproductpackageid = orderproductpackageid
				this.scrollTop = document.getElementById("modaldialog").scrollTop
				this.motifselectorshown = true
			},
			hideMotifSelector()
			{
				this.motifselectorproductpackageid = null
				this.motifselectorshown = false
				const scrollTop = this.scrollTop
				setTimeout(function () { document.getElementById("modaldialog").scrollTo(0, scrollTop) }, 30)

			},
			search(input)
			{
				if (input.length < 1) { return [] }
				return this.countries.filter(country =>
				{
					return country.toLowerCase().startsWith(input.toLowerCase())
				})
			},
			async sendReceipt()
			{
				if (confirm("Er du sikker på du vil sende kvitteringen til kunden?"))
				{
					this.setAppAsBusyModal()
					var result = await this.$store.dispatch(types.ACTION_SEND_RECEIPT_TO_CLIENT, this.orderID)

					if (result && result.status && result.status == 200)
					{
						this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						this.showErrorAlert("Der opstod en fejl ved afsendelse af kvittering. Opdater siden og prøv igen.")
					}
				}
			},
			async sendPaymentLink()
			{
				if (confirm("Er du sikker på du vil sende betalingslink til kunden?"))
				{
					await this.saveData(false, true, "sendpaymentlink")
				}
			},
			async sendPaymentReminder(reminder)
			{
				if (confirm("Er du sikker på du vil sende rykkeren til kunden?"))
				{
					await this.saveData(false, true, "sendpaymentreminder" + reminder)
				}
			},
			showPrettyDate(datestring)
			{
				let date = new Date(datestring)
				var options = { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" }
				return date.toLocaleDateString("da-dk", options)
			},
			getAgreementWebshopDates()
			{
				var dateInterval = ""

				if (this.agreement.startdate || this.agreement.expirationdate)
				{
					var options = { year: "numeric", month: "long", day: "numeric", hour: "numeric", minute: "numeric" }

					let mindate = this.agreement.startdate ? new Date(this.agreement.startdate) : null
					let maxdate = this.agreement.expirationdate ? new Date(this.agreement.expirationdate) : null

					var minmonth = mindate ? mindate.toLocaleString("default", { month: "long" }) : null
					var maxmonth = maxdate ? maxdate.toLocaleString("default", { month: "long" }) : null

					if (mindate && maxdate)
					{
						if (mindate.getFullYear() == maxdate.getFullYear())
						{
							if (mindate.getMonth() == maxdate.getMonth())
							{
								dateInterval = mindate.getDate() + " - " + maxdate.getDate() + ". " + maxmonth + " "
							}
							else
							{
								dateInterval = mindate.getDate() + " " + minmonth + " - " + maxdate.getDate() + " " + maxmonth + " "
							}
						}
						else
						{
							dateInterval = mindate.getDate() + " " + minmonth + " " + mindate.getFullYear() + " - " + maxdate.getDate() + " " + maxmonth + " "
						}
					}
					else if (this.agreement.startdate && !this.agreement.expirationdate)
					{
						let date = new Date(this.agreement.startdate)
						dateInterval = "Fra d. " + date.toLocaleDateString("da-dk", options)
					}
					else if (!this.agreement.startdate && this.agreement.expirationdate)
					{
						let date = new Date(this.agreement.expirationdate)
						dateInterval = "Til d. " + date.toLocaleDateString("da-dk", options)
					}
				}
				else
				{
					dateInterval = "Ingen"
				}

				return dateInterval
			},
			setFreeOrderValue()
			{
				var checkbox = this.$refs.freeordercheckbox

				if (checkbox.checked)
				{
					this.paymentstatus = orderPaymentStatusEnum.FREE
				}
				else
				{
					this.paymentstatus = orderPaymentStatusEnum.AWAITING
				}
			},
			getOrderHasBeenCompleted()
			{
				return this.order.status == orderStatusEnum.COMPLETED || this.order.status == orderStatusEnum.DELIVERED
			},
			getPaymentReminderWasSent()
			{
				if (this.paymentreminder3lastsent && this.paymentreminder3fee && this.paymentreminder3fee > 0)
				{
					return true
				}
				else if (this.paymentreminder2lastsent && this.paymentreminder2fee && this.paymentreminder2fee > 0)
				{
					return true
				}
				else if (this.paymentreminder1lastsent && this.paymentreminder1lastsent > this.paymentlinklastsent)
				{
					return true
				}

				return false
			},
			getOrderReminderFee()
			{
				if (this.paymentreminder3lastsent && this.paymentreminder3fee && this.paymentreminder3fee > 0)
				{
					return this.paymentreminder3fee
				}
				else if (this.paymentreminder2lastsent && this.paymentreminder2fee && this.paymentreminder2fee > 0)
				{
					return this.paymentreminder2fee
				}
				else if (this.paymentreminder1lastsent && this.paymentreminder1lastsent > this.paymentlinklastsent)
				{
					return this.paymentreminder1fee
				}

				return 0
			},
			getOrderPaymentStatus()
			{
				let text = ""
				let status = ""

				switch (this.paymentstatus)
				{
					case orderPaymentStatusEnum.AWAITING:
						text = "Afventer"
						status = "draft"
						break
					case orderPaymentStatusEnum.SUCCEEDED:
						text = "Gennemført"
						status = "completed"
						break
					case orderPaymentStatusEnum.FREE:
						text = "Gratis"
						status = "completed"
						break
					case orderPaymentStatusEnum.REJECTED:
						text = "Afvist"
						status = "cancelled"
						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>"
			},
			async sendWebshopLink()
			{
				if (confirm("Er du sikker på du vil sende webshop link til kunden?"))
				{
					this.setAppAsBusyModal()
					var result = await this.$store.dispatch(types.ACTION_SEND_WEBSHOPLINK_TO_CLIENT, this.personID)

					if (result && result.status && result.status == 200)
					{
						this.status = orderStatusEnum.READYCLIENTNOTIFIED
						this.person.requestlinklastsent = new Date()

						if (!this.person.requestlinkfirstsent)
						{
							this.person.requestlinkfirstsent = new Date()
						}

						this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						this.showErrorAlert("Der opstod en fejl ved afsendelse af linket. Opdater siden og prøv igen.")
					}
				}
			},
			async sendNewWebshopCode()
			{
				if (confirm("Er du sikker på du vil sende en ny webshop kode til kunden?"))
				{
					this.setAppAsBusyModal()
					var result = await this.$store.dispatch(types.ACTION_SEND_NEW_WEBSHOPCODE_TO_CLIENT, this.personID)

					if (result && result.status && result.status == 200)
					{
						this.requestcode = result.data
						this.person.requestcodelastsent = new Date()

						if (!this.person.requestcodefirstsent)
						{
							this.person.requestcodefirstsent = new Date()
						}

						this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						this.showErrorAlert("Der opstod en fejl ved afsendelse af webshop koden. Opdater siden og prøv igen.")
					}
				}
			},
			mediaPropertyChange(property, orderproductpackage)
			{
				if (orderproductpackage.mediaproperties && orderproductpackage.mediaproperties.length > 0)
				{
					orderproductpackage.mediaproperties[0].type = property.value
				}
				else
				{
					orderproductpackage.mediaproperties = [{ type: property.value }]
				}
			},
			getProductPackageMediaPropertySelected(property, productpackage)
			{
				for (var mediaproperty of productpackage.mediaproperties)
				{
					if (mediaproperty.type == property.value)
					{
						return true
					}
				}

				return false
			},
			getProductPackageType(productpackage)
			{
				switch (productpackage.type)
				{
					case productPackageTypeEnum.PICTUREPACKAGE:
						return "Pakke"
					case productPackageTypeEnum.PICTUREPACKAGEEXTRA:
						return "Ekstra ved pakkekøb"
					case productPackageTypeEnum.WITHOUTPICTUREPACKAGE:
						return "Uden pakkekøb"
					case productPackageTypeEnum.ADDON:
						return "Tilkøbsprodukt"
					case productPackageTypeEnum.FREIGHTANDSERVICE:
						return "Fragt og service"
					case productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED:
						return "Fragt og service (Krævet)"
					case productPackageTypeEnum.AFTERPICTUREPACKAGE:
						return "Nyt motiv"
				}
			},
			checkForChanges()
			{
				var changes = false

				changes = changes || (this.status != this.order.status)
				changes = changes || (this.notes != this.order.notes)
				changes = changes || (this.name != this.order.name)
				changes = changes || (this.email != this.order.email)
				changes = changes || (this.mobilenumber != this.order.mobilenumber)
				changes = changes || (this.address != this.order.address)
				changes = changes || (this.zipcode != this.order.zipcode)
				changes = changes || (this.city != this.order.city)
				changes = changes || this.editChanges

				if (changes)
				{
					return !confirm("Der er ændringer der ikke er gemt. Vil du lukke dialogen?")
				}

				return false
			},
			getOrderStatus()
			{
				let text = ""
				let status = ""

				switch (this.status)
				{
					case orderStatusEnum.NOTCREATED:
						text = "Ikke oprettet"
						status = "draft"
						break
					case orderStatusEnum.DRAFT:
						text = "Kladde"
						status = "draft"
						break
					case orderStatusEnum.READY:
						text = "Oprettet"
						status = "ready"

						if (this.paymentreminder3lastsent && this.paymentreminder3fee && this.paymentreminder3fee > 0)
						{
							text = "Rykker 3"
							status = "paymentreminder"
						}
						else if (this.paymentreminder2lastsent && this.paymentreminder2fee && this.paymentreminder2fee > 0)
						{
							text = "Rykker 2"
							status = "paymentreminder"
						}
						else if (this.paymentreminder1lastsent && this.paymentreminder1lastsent > this.paymentlinklastsent)
						{
							text = "Rykker 1"
							status = "paymentreminder"
						}
						else if (this.paymentlinklastsent)
						{
							text = "Betalingslink"
							status = "ready"
						}

						break
					case orderStatusEnum.COMPLETED:

						if (this.paymentstatus == orderPaymentStatusEnum.FREE)
						{
							text = "Gennemført"
						}
						else
						{
							text = "Betalt"
						}

						status = "completed"
						break
					case orderStatusEnum.DELIVERED:
						text = "Sendt til kunde"
						status = "delivered"
						break
					case orderStatusEnum.REFUNDED:
						text = "Refunderet"
						status = "refunded"
						break
					default:
						text = "Ikke oprettet"
						status = "draft"
						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>"
			},
			getPersonStatus()
			{
				let text = ""
				let status = ""

				switch (this.person.status)
				{
					case personStatusEnum.CREATED:
						text = "Kladde"
						status = "draft"
						break
					case personStatusEnum.READY:
						text = "Kan inviteres"
						status = "ready"
					case personStatusEnum.READYCLIENTNOTIFIED:
						text = "Link sendt"
						status = "readyclientnotified"
						break
					case personStatusEnum.CLIENTREQUESTEDRESHOOT:
						text = "Omfotografering"
						status = "clientrequestedreshoot"
						break
					case personStatusEnum.CANCELLED:
						text = "Annulleret"
						status = "cancelled"
						break
					default:
						text = "Ikke oprettet"
						status = "draft"
						break
				}

				return "<div class=\"orderstatus " + status + "\">" + text + "</div>"
			},
			setDraggableSort()
			{
				let sort = 0
				for (var file of this.files)
				{
					sort++
					file.sort = sort
					var sourceFile = this.files.find(f => f.index == file.index)
					sourceFile.sort = sort
				}

				this.editChanges = true
			},
			handleFileUploadChanged()
			{
				if (this.$refs.upload.files.length > 0)
				{
					let index = 1
					let sort = 1
					this.files.forEach(file =>
					{
						if (file.index > index)
						{
							index = file.index
						}

						if (file.sort > sort)
						{
							sort = file.sort
						}
					})

					for (let i = 0; i < this.$refs.upload.files.length; i++)
					{
						let file = this.$refs.upload.files[i]
						file.index = (i + index) + 1
						file.sort = (i + sort) + 1
						file.isnew = true
						file.url = this.getImagePreviewUrl(file)
						this.files.push(file)
					}

					this.$refs.imagesgroup.removeAttribute("data-validation")
					this.editChanges = true
				}
			},
			getImagePreviewUrl(file)
			{
				if (file.isnew)
				{
					return window.URL.createObjectURL(file)
				}
				else
				{
					return file.url + this.getNonXHRParameter()
				}
			},
			removeFile(key)
			{
				this.files = this.files.filter(function (file)
				{
					return file.index != key
				})

				this.orderproductpackages.forEach(orderproductpackage =>
				{
					if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
					{
						var selectedmediafile = orderproductpackage.selectedmediafiles[0]

						if (selectedmediafile && selectedmediafile.personmediafile && selectedmediafile.personmediafile.index == key)
						{
							orderproductpackage.selectedmediafiles = []
						}
					}
				})

				this.editChanges = true
			},
			editPerson()
			{
				let routeData = this.$router.resolve({ name: "PersonEdit", query: { personid: this.personID, customerid: this.customerID } })
				window.open(routeData.route.path, "_blank")
			},
			gotoPerson(direction, dontCheckForChanges)
			{
				if (!dontCheckForChanges && this.checkForChanges())
				{
					return
				}

				if (this.dialogMode == "Edit")
				{
					this.dataLoaded = false
				}

				if (direction == -1)
				{
					this.$router.push({ name: "OrderEdit", params: { personid: this.personID, persongroupid: this.persongroupID, orderid: 0, personid: this.previousPersonID, isfind: (this.isFind ? "1" : "0"), isfromorders: (this.isFromOrders ? "1" : "0") } })
				}
				else if (direction == 1)
				{
					this.$router.push({ name: "OrderEdit", params: { personid: this.personID, persongroupid: this.persongroupID, orderid: 0, personid: this.nextPersonID, isfind: (this.isFind ? "1" : "0"), isfromorders: (this.isFromOrders ? "1" : "0") } })
				}
			},
			collapseEdit()
			{
				if (this.editIsCollapsed)
				{
					this.$refs.collapseditanchor.setAttribute("data-ic", "1")
				}
				else
				{
					this.$refs.collapseditanchor.setAttribute("data-ic", "0")
				}

				this.editIsCollapsed = !this.editIsCollapsed
			},
			removeOrderProductPackage(orderproductpackage)
			{
				this.orderproductpackages = this.orderproductpackages.filter(opp => opp.id != orderproductpackage.id)
				this.orderproductpackages = this.orderproductpackages.filter(opp => opp.orderproductpackageparentid != orderproductpackage.id)
				this.editChanges = true
			},
			setChildOrderProductPackageQuantity(element, quantityChange, orderproductpackage)
			{
				let childorderproductpackage = this.orderproductpackages.find(opp => opp.productpackageid == element.productpackageid && opp.orderproductpackageparentid == orderproductpackage.id)

				if (childorderproductpackage)
				{
					childorderproductpackage.quantity = childorderproductpackage.quantity + quantityChange

					if (childorderproductpackage.quantity == 0)
					{
						this.orderproductpackages = this.orderproductpackages.filter(opp => opp.productpackageid != element.productpackageid &&
							(opp.orderproductpackageparentid == 0 || opp.orderproductpackageparentid == orderproductpackage.id))
					}
				}
				else
				{
					let newOrderProductPackageId = -1

					this.orderproductpackages.forEach(orderproductpackage =>
					{
						if (orderproductpackage.id < 1)
						{
							newOrderProductPackageId = orderproductpackage.id - 1
						}
					})

					childorderproductpackage =
					{
						id: newOrderProductPackageId,
						orderproductpackageparentid: orderproductpackage.id,
						agreementid: this.agreementID,
						orderid: this.orderID,
						personid: this.personID,
						selectedmediafiles: [],
						mediaproperties: [],
						productpackageid: element.productpackageid,
						type: element.type,
						quantity: 1,
						productpackageprice: element.productpackage.price,
						productpackage: element.productpackage
					}

					this.orderproductpackages.push(childorderproductpackage)
				}

				this.editChanges = true
			},
			getChildProductPackageQuantity(element, orderproductpackage)
			{
				const childorderproductpackage = this.orderproductpackages.find(opp => opp.productpackageid == element.productpackageid && opp.orderproductpackageparentid == orderproductpackage.id)

				if (childorderproductpackage)
				{
					return childorderproductpackage.quantity
				}

				return 0
			},
			setExtraOrderProductPackageQuantity(element, quantityChange)
			{
				let extraorderproductpackage = this.orderproductpackages.find(opp => opp.productpackageid == element.productpackageid)

				if (extraorderproductpackage)
				{
					extraorderproductpackage.quantity = extraorderproductpackage.quantity + quantityChange

					if (extraorderproductpackage.quantity == 0)
					{
						this.orderproductpackages = this.orderproductpackages.filter(opp => opp.productpackageid != element.productpackageid)
					}
				}
				else
				{
					let newOrderProductPackageId = 0

					this.orderproductpackages.forEach(orderproductpackage =>
					{
						if (orderproductpackage.id < 1)
						{
							newOrderProductPackageId = orderproductpackage.id - 1
						}
					})

					extraorderproductpackage =
					{
						id: newOrderProductPackageId,
						orderproductpackageparentid: 0,
						agreementid: this.agreementID,
						orderid: this.orderID,
						personid: this.personID,
						selectedmediafiles: [],
						mediaproperties: [],
						productpackageid: element.productpackageid,
						type: element.type,
						quantity: 1,
						productpackageprice: element.productpackage.price,
						productpackage: element.productpackage
					}

					this.orderproductpackages.push(extraorderproductpackage)
				}

				this.editChanges = true
			},
			getExtraProductPackageQuantity(element)
			{
				const orderproductpackage = this.orderproductpackages.find(pp => (pp.personid == this.personID || (pp.productpackage.type == productPackageTypeEnum.FREIGHTANDSERVICE || pp.productpackage.type == productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED)) && pp.productpackageid == element.productpackageid)
				return orderproductpackage ? orderproductpackage.quantity : 0
			},
			getExtraProductPackagePrice(element)
			{
				var applyDiscount = false
				var price = 0
				const orderproductpackage = this.orderproductpackages.find(pp => pp.productpackageid == element.productpackageid)

				if (orderproductpackage)
				{
					price = orderproductpackage.quantity * element.productpackageprice

					if (orderproductpackage && orderproductpackage.productpackage != null)
					{
						applyDiscount = (orderproductpackage.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && orderproductpackage.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED) && this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100
					}
				}
				else
				{
					applyDiscount = (element.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && element.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED) && this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100
					price = element.productpackageprice
				}

				if (applyDiscount)
				{
					return this.getDiscountPrice(this.discountPercentCalculated, price)
				}
				else
				{
					return price
				}
			},
			getProductPackageQuantity(element, orderproductpackage)
			{
				if (orderproductpackage.productpackageid == element.productpackageid)
				{
					return orderproductpackage.quantity
				}

				return 0
			},
			getProductPackagePrice(element, orderproductpackage)
			{
				var applyDiscount = false

				if (orderproductpackage && orderproductpackage.productpackage != null)
				{
					applyDiscount = (orderproductpackage.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && orderproductpackage.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED) && this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100
				}

				var productPackage = this.allProductPackages.find(productpackage => productpackage.productpackageid == element.productpackageid)
				var existingProductpackage = this.orderproductpackages.find(opp => opp.productpackageid == element.productpackageid)
				var price = productPackage != null ? productPackage.productpackageprice : 0

				if (existingProductpackage)
				{
					if (existingProductpackage.quantity == 0)
					{
						price = productPackage.productpackageprice
					}
					else
					{
						price = productPackage.productpackageprice * existingProductpackage.quantity
					}
				}
				else
				{
					applyDiscount = (element.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && element.productpackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED) && this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100
					price = element.productpackageprice
				}

				if (applyDiscount)
				{
					return this.getDiscountPrice(this.discountPercentCalculated, price)
				}
				else
				{
					return price
				}
			},
			getDiscountPrice(discountPercent, price)
			{
				return Math.ceil(price - (price * discountPercent / 100))
			},
			getOrderTotalPrice()
			{
				var totalPrice = 0

				for (let orderProductPackage of this.orderproductpackages)
				{
					if (orderProductPackage.quantity > 0)
					{
						var productPackage = this.allProductPackages.find(productpackage => productpackage.productpackageid == orderProductPackage.productpackageid)
						totalPrice += productPackage.productpackageprice * orderProductPackage.quantity
					}
				}

				return totalPrice + this.getOrderReminderFee()
			},
			getOrderTotalPriceWithDiscount()
			{
				var totalPrice = this.getOrderTotalPrice()

				if (this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100)
				{
					totalPrice = this.getDiscountPrice(this.discountPercentCalculated, totalPrice)
				}

				return totalPrice
			},
			getOrderDiscount()
			{
				return Math.ceil(this.getOrderTotalPrice() * this.discountPercentCalculated / 100)
			},
			getOrderTotalPricePerson()
			{
				var totalPrice = 0

				for (let productPackage of this.orderproductpackages)
				{
					if (productPackage.quantity > 0 && productPackage.personid == this.personID && (productPackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && productPackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED))
					{
						totalPrice += productPackage.productpackageprice * productPackage.quantity
					}
				}

				if (this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100)
				{
					totalPrice = this.getDiscountPrice(this.discountPercentCalculated, totalPrice)
				}

				return totalPrice
			},
			getOrderTotalPriceOtherPersons()
			{
				var totalPrice = 0

				for (let productPackage of this.orderproductpackages)
				{
					if (productPackage.quantity > 0 && productPackage.personid != this.personID && (productPackage.type != productPackageTypeEnum.FREIGHTANDSERVICE && productPackage.type != productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED))
					{
						totalPrice += productPackage.productpackageprice * productPackage.quantity
					}
				}

				if (this.discountPercentCalculated > 0 && this.discountPercentCalculated <= 100)
				{
					totalPrice = this.getDiscountPrice(this.discountPercentCalculated, totalPrice)
				}

				return totalPrice
			},
			getOrderTotalPriceServicePackages()
			{
				var totalPrice = 0

				for (let productPackage of this.orderproductpackages)
				{
					if (productPackage.quantity > 0 && (productPackage.type == productPackageTypeEnum.FREIGHTANDSERVICE || productPackage.type == productPackageTypeEnum.FREIGHTANDSERVICEREQUIRED))
					{
						totalPrice += productPackage.productpackageprice * productPackage.quantity
					}
				}

				return totalPrice
			},
			getOrderDate(datestring)
			{
				var options = { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" }
				let date = new Date(datestring)
				return date.toLocaleDateString("da-dk", options)
			},
			copyOrderingUrl()
			{
				var input = this.$refs.orderingUrlHiddenInput
				input.value = this.getOrderingUrl()
				input.select()
				input.setSelectionRange(0, 99999) /*For mobile devices*/
				document.execCommand("copy")
				this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
			},
			getOrderingUrl()
			{
				var url = process.env.VUE_APP_ROOT_WEB + "?" + this.requestkey

				if (window.location.toString().indexOf("://localhost") > -1 || window.location.toString().indexOf(".local") > -1)
				{
					url = process.env.VUE_APP_ROOT_WEB_LOCAL + "?" + this.requestkey
				}
				else if (window.location.toString().indexOf("://192.168.1") > -1)
				{
					url = process.env.VUE_APP_ROOT_WEB_DEV + "?" + this.requestkey
				}
				else if (window.location.toString().indexOf("egello.com") > -1)
				{
					url = process.env.VUE_APP_ROOT_WEB_TEST + "?" + this.requestkey
				}

				return url
			},
			close()
			{
				if (this.checkForChanges())
				{
					return
				}

				if (this.isFind)
				{
					this.persongroupID = this.$route.params.persongroupid
					var searchData = JSON.parse(localStorage.getItem("ordersearchdata"))
					this.$router.push({ name: "FindOrdersResult", params: { agreementid: searchData.agreementid, customerid: searchData.customerid, persongroupid: searchData.persongroupid, findorderinput: searchData.findorderinput } })
					localStorage.removeItem("ordersearchdata")
				}
				else if (this.isFromOrders)
				{
					this.$router.push({ name: "Orders", params: {} })
				}
				else
				{
					this.$router.push({ name: "OrdersPersonGroupShow", params: { customerid: this.customerID, persongroupid: this.persongroupID } })
				}
			},
			getDefaultAgreementProductPackage(type)
			{
				let agreementproductpackage =
				{
					id: 0,
					orderproductpackageparentid: 0,
					agreementid: this.agreementID,
					orderid: this.orderID,
					personid: this.personID,
					selectedmediafiles: [],
					mediaproperties: [],
					productpackageid: 0,
					type: (type == "afterpicturepackage" ? productPackageTypeEnum.AFTERPICTUREPACKAGE : productPackageTypeEnum.PICTUREPACKAGE),
					quantity: 1,
					productpackageprice: 0,
					productpackage: null
				}

				if (this.agreement.productpackages && this.agreement.productpackages.length > 0)
				{
					var defaultProductPackage = null

					this.allProductPackages.forEach(pp =>
					{
						if (!defaultProductPackage && type == "afterpicturepackage" && pp.productpackage.type == productPackageTypeEnum.AFTERPICTUREPACKAGE)
						{
							var agreementProductPackage = this.agreement.productpackages.find(app => app.productpackageid == pp.productpackageid)

							if (agreementProductPackage)
							{
								defaultProductPackage = pp
							}
						}
						else if (!defaultProductPackage && (!type || type == "picturepackage") && pp.productpackage.type == productPackageTypeEnum.PICTUREPACKAGE)
						{
							var agreementProductPackage = this.agreement.productpackages.find(app => app.productpackageid == pp.productpackageid)

							if (agreementProductPackage)
							{
								defaultProductPackage = pp
							}
						}
					})

					if (defaultProductPackage)
					{
						//agreementproductpackage.name = defaultProductPackage.name
						//agreementproductpackage.internalname = defaultProductPackage.internalname
						//agreementproductpackage.productpackage = defaultProductPackage.productpackage
						// agreementproductpackage.productpackage = defaultProductPackage
						agreementproductpackage.orderproductpackageid = 0
						agreementproductpackage.orderid = this.orderID
						// agreementproductpackage.productpackageid = defaultProductPackage.productpackageid
						// agreementproductpackage.productpackageprice = defaultProductPackage.productpackageprice
						agreementproductpackage.type = defaultProductPackage.type
						agreementproductpackage.quantity = 0
					}
				}

				return agreementproductpackage
			},
			async loadData()
			{
				this.setAppAsBusyModal()
				this.agreementID = this.$route.params.agreementid
				this.customerID = this.$route.params.customerid
				this.persongroupID = this.$route.params.persongroupid
				this.orderID = this.$route.params.orderid ? this.$route.params.orderid : 0
				this.personID = this.$route.params.personid
				this.isFind = this.$route.params.isfind == "1"
				this.isFromOrders = this.$route.params.isfromorders == "1"
				this.$refs.name.focus()

				if (this.agreementID && this.customerID && this.personID)
				{
					// Get agreement
					var agreementResult = await this.$store.dispatch(types.ACTION_GET_AGREEMENT, this.agreementID)

					if (agreementResult && agreementResult.status && agreementResult.status == 200)
					{
						this.agreement = agreementResult.data

						if (this.agreement.language === "en")
						{
							this.agreementLanguage = "Engelsk webshop"
						}
						else
						{
							this.agreementLanguage = "Dansk webshop"
						}
					}

					// Get person order info
					var personResult = await this.$store.dispatch(types.ACTION_GET_PERSON_ORDERINFORMATION, { customerid: this.customerID, agreementid: this.agreementID, personid: this.personID, persongroupid: this.persongroupID, orderid: this.orderID })

					if (personResult && personResult.status && personResult.status == 200)
					{
						var existingOrderID = personResult.data.existingorderid

						// TODO: Fix so we dont redirect just to edit an existing order here.
						if (this.orderID == 0 && existingOrderID != 0)
						{
							this.$router.push({ name: "OrderEdit", params: { personid: this.personID, persongroupid: this.persongroupID, orderid: existingOrderID, isfind: (this.isFind ? "1" : "0"), isfromorders: (this.isFromOrders ? "1" : "0") } })
						}
						else (this.orderID != 0 && existingOrderID != 0 & this.orderID != existingOrderID)
						{
							this.$router.push({ name: "OrderEdit", params: { personid: this.personID, persongroupid: this.persongroupID, orderid: existingOrderID, isfind: (this.isFind ? "1" : "0"), isfromorders: (this.isFromOrders ? "1" : "0") } })
						}

						this.person = personResult.data.baseperson
						this.person.firstname = this.person.information.firstname
						this.person.lastname = this.person.information.lastname
						this.person.address = this.person.information.address
						this.person.zipcode = this.person.information.zipcode
						this.person.city = this.person.information.city
						this.person.emailaddress = this.person.information.emailaddress
						this.person.mobilenumber = this.person.information.mobilenumber
						this.person.customername = personResult.data.customername
						this.person.persongroupname = personResult.data.persongroupname
						this.person.persongroupid = personResult.data.persongroupid
						this.persongroupid = personResult.data.persongroupid

						this.previousPersonID = personResult.data.previouspersonid
						this.nextPersonID = personResult.data.nextpersonid
						this.dialogTitle = "bestilling for " + this.person.firstname + " " + this.person.lastname

						this.files = []
						this.loadMediaProperties()
						await this.loadProductPackages()

						if (this.person.mediafiles && this.person.mediafiles.length > 0)
						{
							this.person.mediafiles.forEach(mediafile =>
							{
								if (!this.files.find(mf => mf.id == mediafile.id))
								{
									var file =
									{
										id: mediafile.id,
										agreementid: mediafile.agreementid,
										index: mediafile.index,
										sort: mediafile.sort,
										name: mediafile.mediafile.originalfilename,
										mediafileid: mediafile.mediafileid,
										personid: mediafile.personid,
										propurl: mediafile.propurl,
										url: mediafile.url
									}

									this.files.push(file)
								}
							})
						}
						else
						{
							this.person.mediafiles = []
						}

						// Create order
						if (this.orderID == 0)
						{
							this.dialogTitle = "Opret " + this.dialogTitle
							this.dialogMode = "create"

							if (this.person.type == personTypeEnum.CHILD)
							{
								// Order
								this.orderid = 0
								this.status = 0
								this.paymentstatus = 1
								this.createddate = ""
								this.statuschangeddate = ""
								this.discountpercent = 0
								this.notes = ""
								this.name = this.person.information.clientname ? this.person.information.clientname : ""
								this.email = this.person.information.clientemailaddress ? this.person.information.clientemailaddress : ""
								this.mobilenumber = this.person.information.clientmobilenumber ? this.person.information.clientmobilenumber : ""
								this.address = this.person.address ? this.person.address : ""
								this.zipcode = this.person.zipcode ? this.person.zipcode : ""
								this.city = this.person.city ? this.person.city : ""
								this.clientnotes = ""
								this.transactionid = ""
								this.totalprice = ""
								this.orderproductpackages = []

								// Default package creation disabled for now.
								/*
								const agreementproductpackage = this.getDefaultAgreementProductPackage()
								this.orderproductpackages.push(agreementproductpackage)
								*/

								// Person
								this.requestkey = ""
								this.requestcode = ""
								this.webshopperiod = null
								this.expirationdate = ""

								this.order =
								{
									id: 0,
									agreementid: this.agreementID,
									customerid: 0,
									status: 0,
									notes: "",
									productpackages: [],
									clientnotes: "",
									name: this.name,
									email: this.email,
									mobilenumber: this.mobilenumber,
									address: this.address,
									city: this.city,
									zipcode: this.zipcode,
									paymentstatus: 1,
									transactionid: null,
									totalprice: 0,
								}
							}
							else if (this.person.type == personTypeEnum.EMPLOYEE)
							{
								this.email = this.person.emailaddress
							}
						}
						// Edit order
						else
						{
							this.dialogTitle = "Rediger " + this.dialogTitle
							this.dialogMode = "edit"
							var orderResult = await this.$store.dispatch(types.ACTION_GET_ORDER, this.orderID)

							if (orderResult.status == 200)
							{
								this.$refs.SaveButton.innerText = "Gem bestilling"
								this.$refs.SaveAndContinueButton.innerText = "Gem og fortsæt"
								this.order = orderResult.data

								// Order
								this.orderid = orderResult.data.id
								this.status = orderResult.data.status
								this.paymentstatus = orderResult.data.paymentstatus
								this.createddate = orderResult.data.createddate
								this.statuschangeddate = orderResult.data.statuschangeddate
								this.discountpercent = orderResult.data.discountpercent
								this.notes = orderResult.data.notes
								this.name = orderResult.data.name
								this.email = orderResult.data.email
								this.mobilenumber = orderResult.data.mobilenumber
								this.address = orderResult.data.address
								this.zipcode = orderResult.data.zipcode
								this.city = orderResult.data.city
								this.productpackages = orderResult.data.productpackages
								this.clientnotes = orderResult.data.clientnotes
								this.transactionid = orderResult.data.transactionid
								this.paymentlinklastsent = orderResult.data.paymentlinklastsent
								this.paymentreminder1lastsent = orderResult.data.paymentreminder1lastsent
								this.paymentreminder1fee = orderResult.data.paymentreminder1fee
								this.paymentreminder2lastsent = orderResult.data.paymentreminder2lastsent
								this.paymentreminder2fee = orderResult.data.paymentreminder2fee
								this.paymentreminder3lastsent = orderResult.data.paymentreminder3lastsent
								this.paymentreminder3fee = orderResult.data.paymentreminder3fee
								this.totalprice = orderResult.data.totalprice
								this.orderproductpackages = JSON.parse(JSON.stringify(orderResult.data.productpackages))

								var currentPersonID = this.personID

								this.orderproductpackages.forEach(pp =>
								{
									pp.type = pp.productpackage.type

									if (pp.selectedmediafiles && pp.selectedmediafiles.length > 0)
									{
										let mediaFile = this.files.find(mf => mf.mediafileid === pp.selectedmediafiles[0].mediafileid)
										pp.selectedmediafiles[0].personmediafile = mediaFile
									}

									if (pp.personid != currentPersonID)
									{
										this.orderPersonCount = this.orderPersonCount + 1
									}
								})

								// Person specific data
								this.expirationdate = this.person.expirationdate
								this.requestkey = this.person.requestkey
								this.requestcode = this.person.requestcode
								this.webshopperiod =
								{
									start: this.person.startdate ? this.person.startdate : null,
									end: this.person.expirationdate ? this.person.expirationdate : null
								}

								if (orderResult.data.paymentstatus == orderPaymentStatusEnum.FREE)
								{
									var freeCheckbox = this.$refs.freeordercheckbox
									freeCheckbox.checked = true
								}
							}
							else
							{
								this.setAppAsIdle()
								logError("OrderEdit.mounted() loadperson")
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							}
						}

						this.dataloaded = true
						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("OrderEdit.mounted() loadperson")
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.$router.push({ name: "Orders" })
					}
				}
				else
				{
					this.setAppAsIdle()
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.$router.push({ name: "Orders" })
				}
			},
			async saveData(continueToNextOrder, onlyDoUpdate, action)
			{
				var valid = true
				var validationFocus = false

				if (this.email.length == 0 && (this.mobilenumber.length == 0 || this.mobilenumber.length < 8))
				{
					this.$refs.emailgroup.setAttribute("data-validation", "Indtast venligst en e-mail adresse eller et mobilnummer")
					valid = false

					if (!validationFocus)
					{
						this.$refs.email.focus()
						validationFocus = true
					}
				}
				else if (this && this.$refs && this.$refs.emailgroup)
				{
					this.$refs.emailgroup.removeAttribute("data-validation")
				}

				if (this.mobilenumber.length > 0 && this.mobilenumber.length < 8)
				{
					this.$refs.mobilenumbergroup.setAttribute("data-validation", "Indtast venligst et korrekt mobilnummer")
					valid = false

					if (!validationFocus)
					{
						this.$refs.mobilenumber.focus()
						validationFocus = true
					}
				}
				else if (this && this.$refs && this.$refs.mobilenumbergroup)
				{
					this.$refs.mobilenumbergroup.removeAttribute("data-validation")
				}

				/*
				// Pictures validation
				if (!this.files || this.files.length == 0)
				{
					this.$refs.imagesgroup.setAttribute("data-validation", "Upload venligst mindst et billede")
					valid = false

					if (!validationFocus)
					{
						this.$refs.imagesgroup.focus()
						validationFocus = true
					}
				}
				else
				{
					this.$refs.imagesgroup.removeAttribute("data-validation")
				}*/

				/*
				// Productpackage validation
				if (!this.orderproductpackages || this.orderproductpackages.length == 0)
				{
					this.$refs.productpackagesgroup.setAttribute("data-validation", "Vælg venligst mindst en produkt pakke")
					valid = false
				}*/

				if (this.picturePackageOrderProductPackages && this.picturePackageOrderProductPackages.length > 0)
				{
					// Motif selection validation
					this.picturePackageOrderProductPackages.forEach(orderproductpackage =>
					{
						if (valid && !orderproductpackage.selectedmediafiles || orderproductpackage.selectedmediafiles.length == 0)
						{
							this.$refs.productpackagesgroup.setAttribute("data-validation", "Vælg venligst et motiv til alle billede pakker")
							valid = false
						}
					})

					// Package type selection validation
					this.picturePackageOrderProductPackages.forEach(orderproductpackage =>
					{
						if (valid && !orderproductpackage.productpackageid || orderproductpackage.productpackageid == 0)
						{
							this.$refs.productpackagesgroup.setAttribute("data-validation", "Vælg venligst en pakke type for alle billede pakker")
							valid = false
						}
					})

					// Color selection validation
					if (valid)
					{
						this.picturePackageOrderProductPackages.forEach(orderproductpackage =>
						{
							if (valid && orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0 &&
								orderproductpackage.mediaproperties && orderproductpackage.mediaproperties.length == 0)
							{
								this.$refs.productpackagesgroup.setAttribute("data-validation", "Vælg venligst motiv farve for alle billede pakker")
								valid = false
							}
						})
					}
				}

				if (!valid || this.isAppBusy)
				{
					return
				}

				this.setAppAsBusy()

				this.order.customerid = this.customerID
				this.order.name = this.name
				this.order.email = this.email
				this.order.mobilenumber = this.mobilenumber
				this.order.address = this.address
				this.order.zipcode = this.zipcode
				this.order.city = this.city
				this.order.notes = this.notes
				this.order.paymentstatus = this.paymentstatus
				this.order.discountpercent = this.discountpercent


				// Update media files
				let personMediaFilesHasChange = false

				this.files.forEach(mediaFile =>
				{
					var existingMediaFile = this.person.mediafiles.find(mf => mf.index == mediaFile.index && !mediaFile.isnew)

					// Update existing mediafile
					if (existingMediaFile)
					{
						if (existingMediaFile.index != mediaFile.index)
						{
							existingMediaFile.index = mediaFile.index
							personMediaFilesHasChange = true
						}

						if (existingMediaFile.sort != mediaFile.sort)
						{
							existingMediaFile.sort = mediaFile.sort
							personMediaFilesHasChange = true
						}
					}
					// Add new mediafile
					else if (existingMediaFile == null)
					{
						this.person.mediafiles.push(mediaFile)
						personMediaFilesHasChange = true
					}
				})

				this.person.mediafiles.forEach(mediaFile =>
				{
					var clientMediaFile = this.files.find(mf => mf.id == mediaFile.id)

					// Remove existing mediafile
					if (!clientMediaFile && !mediaFile.isnew)
					{
						this.person.mediafiles = this.person.mediafiles.filter(mf => mf.id != mediaFile.id)
						personMediaFilesHasChange = true
					}
				})

				// Update person media files
				if (personMediaFilesHasChange)
				{
					let formData = new FormData()

					for (var file of this.files)
					{
						if (file.isnew)
						{
							formData.append("files" + file.index, file)
						}
					}

					formData.append("mediafilesJson", JSON.stringify(this.person.mediafiles))

					let data =
					{
						personid: this.personID,
						formData: formData
					}

					var result = await this.$store.dispatch(types.ACTION_UPDATE_PERSON_MEDIAFILES, data)

					if (result.status == 200)
					{
						// Update new files with ids from the server
						this.person.mediafiles.forEach(clientMediaFile =>
						{
							if (clientMediaFile.isnew)
							{
								let mediaFile = result.data.find(mf => mf.index == clientMediaFile.index)

								if (mediaFile)
								{
									clientMediaFile.personmediafileid = mediaFile.id
									clientMediaFile.mediafileid = mediaFile.mediafileid

									this.orderproductpackages.forEach(opp =>
									{
										if (opp.selectedmediafiles && opp.selectedmediafiles.length > 0)
										{
											let selectedMediaFile = opp.selectedmediafiles[0]

											if (selectedMediaFile && selectedMediaFile.personmediafile && selectedMediaFile.personmediafile.index == mediaFile.index)
											{
												selectedMediaFile.personmediafileid = mediaFile.id
												selectedMediaFile.mediafileid = mediaFile.mediafileid
											}
										}
									})
								}
							}
						})
					}
					else
					{
						this.setAppAsIdle()
						logError("Order.saveData()[Update person media files]", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						return
					}
				}

				// Update person data
				var updatePersonData = false
				if (this.person.startdate != (this.webshopperiod && this.webshopperiod.start ? this.webshopperiod.start : null))
				{
					this.person.startdate = this.webshopperiod && this.webshopperiod.start ? this.webshopperiod.start : null
					updatePersonData = true
				}

				if (this.person.expirationdate != (this.webshopperiod && this.webshopperiod.end ? this.webshopperiod.end : null))
				{
					this.person.expirationdate = this.webshopperiod && this.webshopperiod.end ? this.webshopperiod.end : null
					updatePersonData = true
				}

				if ((!this.person.information.emailaddress || this.person.information.emailaddress == null) && this.email && this.email != "")
				{
					this.person.information.emailaddress = this.email
					updatePersonData = true
				}

				if ((!this.person.information.mobilenumber || this.person.information.mobilenumber == null) && this.mobilenumber && this.mobilenumber != "")
				{
					this.person.information.mobilenumber = this.mobilenumber
					updatePersonData = true
				}

				if (this.orderContactInfoChanged)
				{
					if (this.dialogMode == "edit")
					{
						if (confirm("Vil du opdatere webshop oplysninger for " + this.person.firstname + " også?"))
						{
							updatePersonData = true
						}
					}
					else if (this.dialogMode == "create")
					{
						updatePersonData = true

						if ((this.person.information.clientname == this.name && this.name.length > 0) &&
							(this.person.information.clientemailaddress == this.email && this.email.length > 0) &&
							(this.person.information.clientmobilenumber == this.mobilenumber && this.mobilenumber.length > 0))
						{
							updatePersonData = false
						}
					}
				}

				if (updatePersonData)
				{
					this.person.information.clientname = this.name
					this.person.information.clientemailaddress = this.email
					this.person.information.clientmobilenumber = this.mobilenumber
					this.person.address = this.address
					this.person.zipcode = this.zipcode
					this.person.city = this.city
					this.person.persongroups = [{ persongroupid: this.person.persongroupid, personid: this.person.id }]
					var result = await this.$store.dispatch(types.ACTION_UPDATE_PERSON, this.person)

					if (result.status != 200)
					{
						this.setAppAsIdle()
						logError("Order.saveData()[Update person webshop period]", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						return
					}
				}

				// Product package check
				this.orderproductpackages.forEach(orderproductpackage =>
				{
					var existingProductPackage = this.order.productpackages.find(pp => pp.id == orderproductpackage.id)

					// Update existing package
					if (existingProductPackage != null)
					{
						existingProductPackage.quantity = orderproductpackage.quantity
						existingProductPackage.productpackageid = orderproductpackage.productpackageid

						if (existingProductPackage.mediaproperties &&
							existingProductPackage.mediaproperties.length > 0 &&
							orderproductpackage.type == productPackageTypeEnum.PICTUREPACKAGE)
						{
							existingProductPackage.mediaproperties[0].type = orderproductpackage.mediaproperties[0].type
						}
					}
					// Add new package
					else if (existingProductPackage == null)
					{
						if (orderproductpackage.mediaproperties && orderproductpackage.mediaproperties.length > 0)
						{
							// orderproductpackage.mediaproperties = [{ type: orderproductpackage.mediaproperties[0].type }]
						}

						this.order.productpackages.push(orderproductpackage)
					}
				})

				this.order.productpackages.forEach(orderproductpackage =>
				{
					var clientProductPackage = this.orderproductpackages.find(pp => pp.id == orderproductpackage.id)

					// Remove existing package
					if (!clientProductPackage)
					{
						this.order.productpackages = this.order.productpackages.filter(pack => pack.id != orderproductpackage.id)
					}
					// Check media files ids
					else
					{
						if (orderproductpackage.selectedmediafiles && orderproductpackage.selectedmediafiles.length > 0)
						{
							if (clientProductPackage.selectedmediafiles && clientProductPackage.selectedmediafiles.length > 0)
							{
								orderproductpackage.selectedmediafiles[0].personmediafileid = clientProductPackage.selectedmediafiles[0].personmediafileid
								orderproductpackage.selectedmediafiles[0].mediafileid = clientProductPackage.selectedmediafiles[0].mediafileid
							}
						}
						else if (clientProductPackage.selectedmediafiles && clientProductPackage.selectedmediafiles.length > 0)
						{
							orderproductpackage.selectedmediafiles =
								[{
									personmediafileid: clientProductPackage.selectedmediafiles[0].personmediafileid,
									mediafileid: clientProductPackage.selectedmediafiles[0].mediafileid
								}]
						}
					}
				})

				if (this.dialogMode == "edit")
				{
					var data = { order: this.order, personid: this.personID }
					var result = await this.$store.dispatch(types.ACTION_UPDATE_ORDER, data)

					if (result.status == 200)
					{
						if (action && action == "sendpaymentlink")
						{
							var data = { orderid: this.orderID, personid: this.personID }
							var result = await this.$store.dispatch(types.ACTION_SEND_PAYMENTLINK_TO_CLIENT, data)

							if (result && result.status && result.status == 200)
							{
								this.paymentlinklastsent = new Date()
								this.paymentreminder1fee = 0
								this.paymentreminder2fee = 0
								this.paymentreminder3fee = 0
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.setAppAsIdle()
							}
							else
							{
								this.setAppAsIdle()
								this.showErrorAlert("Der opstod en fejl ved afsendelse af betalingslink. Opdater siden og prøv igen.")
							}
						}
						if (action && (action == "sendpaymentreminder1" || action == "sendpaymentreminder2" || action == "sendpaymentreminder3"))
						{
							const reminder = action.slice(-1)
							var data = { orderid: this.orderID, personid: this.personID, reminder: reminder }
							var result = await this.$store.dispatch(types.ACTION_SEND_PAYMENTREMINDER_TO_CLIENT, data)

							if (result && result.status && result.status == 200)
							{
								if (action == "sendpaymentreminder1")
								{
									this.paymentreminder1lastsent = new Date()
								}
								else if (action == "sendpaymentreminder2")
								{
									this.paymentreminder2lastsent = new Date()
								}
								else if (action == "sendpaymentreminder3")
								{
									this.paymentreminder3lastsent = new Date()
								}

								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.setAppAsIdle()
							}
							else
							{
								this.setAppAsIdle()
								this.showErrorAlert("Der opstod en fejl ved afsendelse af betalingslink. Opdater siden og prøv igen.")
							}
						}
						else if (!onlyDoUpdate)
						{
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.setAppAsIdle()
							if (continueToNextOrder)
							{
								this.gotoPerson(1, false)
							}
							else
							{
								this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID } })
							}
						}
						else
						{
							this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
							this.setAppAsIdle()
						}
					}
					else
					{
						this.setAppAsIdle()
						logError("Order.saveData()", result.status)
						alert("Der opstod en fejl. Opdater siden og prøv igen.")
					}
				}
				else
				{
					var data = { order: this.order, personid: this.personID }
					var result = await this.$store.dispatch(types.ACTION_ADD_ORDER, data)

					if (result && result.status && (result.status == 200 || result.status == 201))
					{
						this.setAppAsIdle()
						this.order = result.data
						
						this.setAppFeedbackState(appFeedbackStateEnum.ADDED)

						if (continueToNextOrder)
						{
							this.gotoPerson(1, true)
						}
						else
						{
							this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID } })
						}
					}
					else if (result.status == 400)
					{
						this.setAppAsIdle()
					}
					else
					{
						this.setAppAsIdle()
						logError("Order.saveData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					}
				}
			},
			async loadProductPackages()
			{
				var productPackagesResult = await this.$store.dispatch(types.ACTION_GET_PRODUCTPACKAGES)
				this.allProductPackages = []

				if (productPackagesResult.status == 200)
				{
					if (productPackagesResult.data && productPackagesResult.data.length > 0)
					{
						for (var productpackage of productPackagesResult.data)
						{
							// Convert to orderproductpackage structure
							var addProductPackage =
							{
								id: 0,
								name: productpackage.name,
								internalname: productpackage.internalname,
								productpackage: productpackage,
								orderproductpackageid: 0,
								orderid: this.orderID,
								mediafiles: [],
								mediaproperties: [],
								selectedmediafiles: [],
								productpackageid: productpackage.id,
								productpackageprice: productpackage.price,
								type: productpackage.type,
								quantity: 0,
								personid: this.personID,
								agreementid: this.agreementID
							}

							this.allProductPackages.push(addProductPackage)
						}
					}
				}
				else
				{
					this.setAppAsIdle()
					logError("AgreementEdit.loadProductPackages()", error)
					this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
					this.returnToList()
				}
			},
			loadMediaProperties()
			{
				this.mediaproperties = []

				for (var property of mediaPropertiesList)
				{
					this.mediaproperties.push(property)
				}
			},
			async deleteData()
			{
				if (confirm("Er du sikker? Sletningen kan ikke fortrydes."))
				{
					try
					{
						await this.$store.dispatch(types.ACTION_DELETE_ORDER, this.orderID)
							.then(response =>
							{
								this.setAppAsIdle()
								this.setAppFeedbackState(appFeedbackStateEnum.SUCCESS)
								this.$router.push({ name: "OrdersPersonGroupShow", params: { agreementid: this.agreementID, customerid: this.customerID, persongroupid: this.persongroupID } })
							})
							.catch(error =>
							{
								this.setAppAsIdle()
								logError("Order.deleteData()", error)
								this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
							})
					}
					catch (error)
					{
						this.setAppAsIdle()
						logError("Order.deleteData()", error)
						this.showErrorAlert("Der opstod en fejl. Opdater siden og prøv igen.")
						this.$router.push({ name: "Orders" })
					}
				}
			}
		}
	}
</script>